import AdminPanel from "../components/AdminPanel";
import SectionHeading from "../components/SectionHeading";

export default function Admin() {
  return (
    <section className="section-shell pt-10">
      <div className="surface-panel overflow-hidden p-8 lg:p-10">
        <div className="grid gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-end">
          <SectionHeading
            eyebrow="Admin Panel"
            title="Dreameer Admin"
            copy="Password-protected demo admin with tutor CRUD, image updates, CSV exports, and a clean migration path to Firebase Auth plus Firestore."
          />
          <div className="grid gap-4 sm:grid-cols-3">
            {[
              { label: "Tutor CRUD", value: "Live" },
              { label: "CSV Export", value: "Ready" },
              { label: "Auth Upgrade", value: "Documented" },
            ].map((item) => (
              <div key={item.label} className="metric-tile">
                <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-400">{item.label}</p>
                <p className="mt-3 font-display text-2xl font-extrabold text-ink">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-10">
        <AdminPanel />
      </div>
    </section>
  );
}
